import { render, staticRenderFns } from "./moneyback.vue?vue&type=template&id=3057fb02&"
import script from "./moneyback.vue?vue&type=script&lang=js&"
export * from "./moneyback.vue?vue&type=script&lang=js&"
import style0 from "./moneyback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports